<template>
    <span class="total-price-label">{{ $t('total') }}: {{ $filters.price(totalPrice) }}</span>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class TotalPriceLabel extends Vue {
        @Prop({required: true}) totalPrice
        @Prop() offer
    }

    export default TotalPriceLabel
</script>
